import styled, { css } from 'styled-components';
import {
  MEDIA_CARD_WIDTH,
  MediaCardDescription as MediaCardDescriptionComponent,
  MediaCardTitle as MediaCardTitleComponent,
} from '../MediaCard';
import {
  PlayBlobContainer,
  PlayIconContainer,
  VideoPlayer as VideoPlayerComponent,
} from '../VideoPlayer';

export const MediaCardDescription = styled(MediaCardDescriptionComponent)(
  ({ theme }) => css`
    margin-top: ${theme.sz.s2};
  `,
);

export const MediaCardTitle = styled(MediaCardTitleComponent)(
  () => css`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `,
);

export const LearnablesCount = styled.div(() => css``);

export const NoVideoPlaceholderContainer = styled.div(
  ({ theme }) => css`
    width: 100%;
    height: ${theme.sz.s68};
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${theme.co.neutral98};
  `,
);

export const NoVideoPlaceholder = styled.img(
  () => css`
    width: 100%;
    opacity: 0.4;
  `,
);

export const Topic = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: ${theme.sz.s1};
  `,
);

export const TopicIcon = styled.img(
  ({ theme }) => css`
    width: ${theme.sz.s6};
    max-width: ${theme.sz.s6};
    height: ${theme.sz.s6};
    max-height: ${theme.sz.s6};
  `,
);

export const VideoPlayer = styled(VideoPlayerComponent)(
  ({ theme }) => css`
    width: 100%;
    height: ${theme.sz.s68};

    video {
      width: ${MEDIA_CARD_WIDTH};
      height: ${MEDIA_CARD_WIDTH};
      border-radius: 0;
    }

    ${PlayBlobContainer} {
      width: ${theme.sz.s10};
      height: ${theme.sz.s10};

      path {
        fill: ${theme.co.primary20};
        fill-opacity: 1;
      }
    }

    ${PlayIconContainer} {
      width: ${theme.sz.s5};
      height: ${theme.sz.s6};
      /*! @noflip */
      left: 50%;
      top: 50%;
      /*! @noflip */
      transform: translateX(-40%) translateY(-50%);

      path {
        fill: ${theme.co.secondary20};
      }
    }
  `,
);
